import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, noop } from 'lodash';

import { useStyles } from '~/assets/styles';
import ButtonGroup from '~/components/core/Atomic/ButtonGroup';
import Button from '~/components/core/Atomic/Buttons/Button';
import Grid from '~/components/core/Atomic/Grid/Grid';
import MultiSelectField from '~/components/core/Molecules/Fields/MultiSelectField';
import { FAILING_COLOR } from '~/components/exposures/ExposureUtils';

export const SelectMultipleSearchValues = ({
  id,
  label,
  setState,
  selectedValues,
  entitiesMap,
  disabled,
  showWarning = false,
  warningMessage = '',
  setWarning = noop,
  acceptedEntities = [],
  allowNone = false,
}) => {
  const { classes } = useStyles();
  const entities = isEmpty(acceptedEntities) ? Object.keys(entitiesMap)?.sort() : acceptedEntities;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px', marginLeft: '20px' }}>
        <MultiSelectField
          id={id}
          options={entities}
          value={selectedValues}
          renderValue={(vals) =>
            vals
              .map((key) => entitiesMap[key]?.desc || '')
              .filter(Boolean)
              .join(', ')
          }
          renderOption={(key) => entitiesMap[key]?.desc || ''}
          onChange={(newValues) => {
            if (newValues.length > 0) {
              setState(newValues);
              setWarning(false);
            }
          }}
          label={label}
          className={classes.textFieldRow}
          style={{ width: '300px' }}
          disabled={disabled}
          autoSelectSingleOption={false}
        />
        {showWarning && <div style={{ color: FAILING_COLOR, marginLeft: '5px' }}>{warningMessage}</div>}
      </div>
      <Grid item>
        <ButtonGroup variant="text" size="small">
          <Button
            size="small"
            onClick={() => {
              setState(entities);
              setWarning(false);
            }}
          >
            All
          </Button>
          {!allowNone && (
            <Button
              size="small"
              onClick={() => {
                setState([]);
                setWarning(true);
              }}
            >
              None
            </Button>
          )}
        </ButtonGroup>
      </Grid>
    </div>
  );
};

SelectMultipleSearchValues.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  setState: PropTypes.func.isRequired,
  selectedValues: PropTypes.array.isRequired,
  entitiesMap: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  showWarning: PropTypes.bool,
  warningMessage: PropTypes.string,
  setWarning: PropTypes.func,
  acceptedEntities: PropTypes.arrayOf(PropTypes.string),
  allowNone: PropTypes.bool,
};
